import { RadialLayoutSettings } from "../Topology/RadialLayout";
import { HierarchicalLayoutSettings } from "../Topology/HierarchicalLayout";
import { RingLayoutSettings } from "../Topology/RingLayout";
import { TopoNode } from "../Topology/TopoNode";
import { HashSet } from "../Utils/HashSet";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { TopoUtils } from "../Topology/TopoUtils";


export enum LayoutType { Manual, Radial, Hierarchical, Ring }


export class LayoutSettings
{
	public LayoutType: LayoutType;
	public UseStraightLinks:boolean;
	public RadialSettings: RadialLayoutSettings;
	public HierarchicalSettings: HierarchicalLayoutSettings;
	public RingSettings: RingLayoutSettings;
    public ShowLayer2Links: boolean;
	public ShowVirtualLinks: boolean;
	public ShowWirelessLinks: boolean;
	public ShowIpPhoneLinks: boolean;
	public ShowLinkLabels: boolean;
    public RootNodes: HashSet<TopoNode>;

	constructor()	{
		this.Clear();
	}

	public Clear(): void {
		this.LayoutType = LayoutType.Radial;
        this.UseStraightLinks = true;
        this.ShowLayer2Links = true;
		this.ShowLinkLabels = false;
		this.ShowVirtualLinks = false;
		this.ShowIpPhoneLinks = false;
		this.ShowWirelessLinks = false;
		this.RadialSettings = new RadialLayoutSettings();
		this.HierarchicalSettings = new HierarchicalLayoutSettings();
		this.RingSettings = new RingLayoutSettings();
		this.RootNodes = new HashSet<TopoNode>();
	}

	public Clone(): LayoutSettings
	{
		var result = new LayoutSettings();

		result.LayoutType = this.LayoutType;
		result.UseStraightLinks = this.UseStraightLinks;
		result.RadialSettings = this.RadialSettings.Clone();
		result.HierarchicalSettings = this.HierarchicalSettings.Clone();
		result.RingSettings = this.RingSettings.Clone();
        result.ShowLayer2Links = this.ShowLayer2Links;
		result.ShowVirtualLinks = this.ShowVirtualLinks;
		result.ShowWirelessLinks = this.ShowWirelessLinks;
		result.ShowIpPhoneLinks = this.ShowIpPhoneLinks;
		result.ShowLinkLabels = this.ShowLinkLabels;
		result.RootNodes.UnionWith(this.RootNodes);

		return result;
	}

	public get IsManualLayout(): boolean {
		return this.LayoutType == LayoutType.Manual;
	}

	public Write(obj: any, context: any): void {
		obj.layout_settings = {};
		obj = obj.layout_settings;

		obj.layout_type = LayoutType[this.LayoutType];

		obj.straight_links = ValueEncoder.EncodeBoolean(this.UseStraightLinks);
		obj.layer_2_links = ValueEncoder.EncodeBoolean(this.ShowLayer2Links);
		obj.virtual_links = ValueEncoder.EncodeBoolean(this.ShowVirtualLinks);
		obj.wireless_links = ValueEncoder.EncodeBoolean(this.ShowWirelessLinks);
		obj.ip_phone_links = ValueEncoder.EncodeBoolean(this.ShowIpPhoneLinks);
		obj.show_link_labels = ValueEncoder.EncodeBoolean(this.ShowLinkLabels);

		obj.topo_roots = [];
		ObjSerUtils.WriteObjSerCollection(obj.topo_roots, this.RootNodes, context);

		if (this.RadialSettings)
			this.RadialSettings.Write(obj, context);

		if (this.HierarchicalSettings)
			this.HierarchicalSettings.Write(obj, context);

		if (this.RingSettings)
			this.RingSettings.Write(obj, context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.layout_settings)
			throw new Error();
		obj = obj.layout_settings;

		if (obj.layout_type !== undefined)
			this.LayoutType = LayoutType[<string>obj.layout_type];

		if (obj.straight_links !== undefined)
			this.UseStraightLinks = ValueEncoder.DecodeBoolean(obj.straight_links);

		if (obj.layer_2_links !== undefined)
			this.ShowLayer2Links = ValueEncoder.DecodeBoolean(obj.layer_2_links);

		if (obj.virtual_links !== undefined)
			this.ShowVirtualLinks = ValueEncoder.DecodeBoolean(obj.virtual_links);

		if (obj.wireless_links !== undefined)
			this.ShowWirelessLinks = ValueEncoder.DecodeBoolean(obj.wireless_links);

		if (obj.ip_phone_links !== undefined)
			this.ShowIpPhoneLinks = ValueEncoder.DecodeBoolean(obj.ip_phone_links);

		if (obj.show_link_labels !== undefined)
			this.ShowLinkLabels = ValueEncoder.DecodeBoolean(obj.show_link_labels);

		if (obj.topo_roots !== undefined) {
			obj.topo_roots.forEach((value: any) => {
				let node: TopoNode = TopoUtils.ReadTopoNode(value, context);
				if (node)
					this.RootNodes.Add(node);
				else
					console.log("Root TopoNode could not be deserialized");
			}, this);
		}

		if (obj.radial_layout_settings !== undefined)
			this.RadialSettings.Read(obj, context);

		if (obj.hierarchical_layout_settings !== undefined)
			this.HierarchicalSettings.Read(obj, context);

		if (obj.ring_layout_settings !== undefined)
			this.RingSettings.Read(obj, context);
	}
}
